module.exports = __webpack_public_path__ + "static/media/ArdentPropertiesInc.d05fd31d.jpg";